import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      links={[
        {
          key: 'Blue Shield',
          title: 'Blue Shield',
          href: ''
        }
      ]}
    />
  );
};

export default Footer;
